import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import PortMappingApiUrls from 'src/apiUrls/PortMappingApiUrls'
import React from 'react'
import PortMappingKeys from 'src/constants/locale/key/PortMapping'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    DateTimeRangeFilter: CngDateTimeRangeFilter,
    useDefaultNotification,
    useFetchCustomLookup,
    useFetchCodeMaintenanceLookup
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props
  const fetchCustomLookup = useFetchCustomLookup();
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup();
  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.PORT_MAPPING
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let portMapping = translate(
      Namespace.PORT_MAPPING,
      PortMappingKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: portMapping
      }
    )
    let partyId = translate(
      Namespace.PORT_MAPPING,
      PortMappingKeys.PARTY_ID
    )
    let calistaPortCode = translate(
      Namespace.PORT_MAPPING,
      PortMappingKeys.CALISTA_PORT_CODE
    )
    let partyPortCode = translate(
      Namespace.PORT_MAPPING,
      PortMappingKeys.PARTY_PORT_CODE
    )
    let partyPortDesc = translate(
      Namespace.PORT_MAPPING,
      PortMappingKeys.PARTY_PORT_DESC
    )
    let createdDate = translate(
      Namespace.PORT_MAPPING,
      PortMappingKeys.CREATED_DATE
    )

    return {
      portMapping,
      tableTitle,
      partyId,
      calistaPortCode,
      partyPortCode,
      partyPortDesc,
      createdDate
    }
  }

  const columns = [
    {
      field: "partyId",
      title: translatedTextsObject.partyId,
      customLookup: () => {
        return fetchCustomLookup(
          `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/party/get`,
          {},
          'content',
          'name',
          'id',
          (error) => console.error(error)
        )
      }
    },
    {
      field: "calistaPortCode",
      title: translatedTextsObject.calistaPortCode,
      customLookup: () => {
        return fetchCodeMaintenanceLookup(
          constants.CodeMaintenanceType.PORT,
          (error) => console.error(error)
        )
      }
    },
    {
      field: "partyPortCode",
      title: translatedTextsObject.partyPortCode,
    },
    {
      field: "partyPortDesc",
      title: translatedTextsObject.partyPortDesc,
    },
    {
      field: "createdDate",
      title: translatedTextsObject.createdDate,
      type: "datetime",
      filterComponent: CngDateTimeRangeFilter,
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: PortMappingApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: PortMappingApiUrls.EXPORT }}
              fetch={{ url: PortMappingApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
